import { Search as SearchIcon, X } from "lucide-react";
import * as React from "react";
import { cn } from "../../lib/cn";

export interface SearchProps
  extends Omit<React.ComponentProps<"input">, "type" | "onChange"> {
  value?: string;
  onChange?: (value: string) => void;
  onClear?: () => void;
  containerClassName?: string;
}

export const Search = React.forwardRef<HTMLInputElement, SearchProps>(
  (
    {
      className,
      containerClassName,
      value,
      onChange,
      onClear,
      placeholder = "Search...",
      ...props
    },
    ref
  ) => {
    const hasValue = Boolean(value);

    return (
      <div className={cn("relative w-full", containerClassName)}>
        <SearchIcon className="pointer-events-none absolute left-3.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-[var(--gv-ink-muted)]" />
        <input
          ref={ref}
          type="search"
          value={value}
          placeholder={placeholder}
          onChange={e => onChange?.(e.target.value)}
          className={cn(
            "admin-input h-9 w-full rounded-full border border-[var(--gv-border)] bg-white py-1.5 pl-9 pr-9 text-xs text-[var(--gv-ink)] placeholder:text-[var(--gv-ink-muted)] focus-visible:outline-none focus-visible:border-[var(--gv-brand)]",
            className
          )}
          {...props}
        />
        {hasValue && (
          <button
            type="button"
            aria-label="Clear search"
            onClick={() => {
              onChange?.("");
              onClear?.();
            }}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 rounded-full p-1 text-[var(--gv-ink-muted)] hover:bg-[var(--gv-brand-soft)] hover:text-[var(--gv-ink)]"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    );
  }
);

Search.displayName = "Search";
